import { useState } from 'react';
import { Session } from '../types';
import { useSubmit } from 'react-router';
import { fullstoryEvent } from '@/fullstory/utils/fullstory-event';

interface FilterZipcodeDrawerDialogProps {
  actionData?: { intent?: string; zipcode?: string };
  session?: Session;
  skipOptimisticValue?: boolean;
}

/**
 * Hook to manage the state of the FilterZipcodeDrawerDialog used in the Header.
 */
export function useFilterZipcodeDrawerDialog({
  actionData,
  session,
  skipOptimisticValue = false,
}: FilterZipcodeDrawerDialogProps) {
  const submit = useSubmit();

  const [submittedZipcode, setSubmittedZipcode] = useState<string | undefined>();
  const [zipcodeModalOpen, setZipcodeModalOpen] = useState(false);

  const selectedZipcode =
    actionData?.intent === 'find_nearest_zipcode' && actionData?.zipcode
      ? actionData.zipcode
      : // use the nearest zipcode the user requested one
        !skipOptimisticValue && submittedZipcode
        ? // use optimistic value if submitting
          submittedZipcode
        : // fall back to the database state
          session?.cart?.zipcode;

  const handleZipcodeModalOpen = () => setZipcodeModalOpen(true);
  const handleZipcodeModalClose = () => setZipcodeModalOpen(false);

  const submitZipcode = (zipcode: string) => {
    setSubmittedZipcode(zipcode);
    fullstoryEvent('zipcode_changed', {
      zipcode,
    });
    submit(
      {
        intent: 'add_zipcode',
        zipcode,
      },
      { method: 'post' }
    );
    setZipcodeModalOpen(false);
  };

  return {
    selectedZipcode,
    zipcodeModalOpen,
    submitZipcode,
    handleZipcodeModalOpen,
    handleZipcodeModalClose,
  };
}
